var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvanceFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 4.453V1A.667.667 0 1 0 11 1v3.453a2 2 0 0 0 0 3.76V13a.666.666 0 1 0 1.333 0V8.213a2 2 0 0 0 0-3.76zM11.667 7a.667.667 0 1 1 0-1.333.667.667 0 0 1 0 1.333zm-4 1.453V1a.667.667 0 0 0-1.334 0v7.453a2 2 0 0 0 0 3.76V13a.667.667 0 1 0 1.334 0v-.787a2 2 0 0 0 0-3.76zM7 11a.667.667 0 1 1 0-1.334A.667.667 0 0 1 7 11zM3 3.12V1a.667.667 0 0 0-1.333 0v2.12a2 2 0 0 0 0 3.76V13A.667.667 0 1 0 3 13V6.88a2 2 0 0 0 0-3.76zm-.667 2.547a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334z",
    fill: "#150349"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceFilterIcon);
export default __webpack_public_path__ + "static/media/advance-filter-icon.3275024d468d60bb3bf25a54088b25af.svg";
export { ForwardRef as ReactComponent };